import { Color } from '@kite-js/theme-types';

const green: Color = {
    50: '#e6fce5',
    100: '#a3df9f',
    200: '#1fa716',
    300: '#087a00',
    400: '#084f03',
    500: '#0b3508',
};

export default green;
